import React from 'react';
import { Box, Button, Stack } from '@mui/material';
import { GridActionsCellItem, GridColDef } from '@mui/x-data-grid';
import AddTaskOutlinedIcon from '@mui/icons-material/AddTaskOutlined';
import DoneAllOutlinedIcon from '@mui/icons-material/DoneAllOutlined';
import { FDataGrid, FGridMoneyCell, FGridPercentCell } from '../grid';
import { BudgetExecutionRow } from './budgetexecution.models';
type Props={rows:BudgetExecutionRow[];loading?:boolean;onCommit:(row:BudgetExecutionRow)=>void;onRealize:(row:BudgetExecutionRow)=>void};
export default class ExecutionRegisterGrid extends React.PureComponent<Props>{
 private columns=():GridColDef[]=>[
  {field:'costcentercode',headerName:'Cost Center',width:130},
  {field:'accountcode',headerName:'Account',width:120},
  {field:'name',headerName:'Description',minWidth:250,flex:1},
  {field:'budget',headerName:'Budget',width:145,renderCell:FGridMoneyCell},
  {field:'committed',headerName:'Engagement',width:145,renderCell:FGridMoneyCell},
  {field:'commitmentrate',headerName:'Taux Eng.',width:110,renderCell:FGridPercentCell},
  {field:'realized',headerName:'Réalisation',width:145,renderCell:FGridMoneyCell},
  {field:'realizationrate',headerName:'Taux Réal.',width:110,renderCell:FGridPercentCell},
  {field:'uncommitted',headerName:'Disponible',width:145,renderCell:FGridMoneyCell},
  {field:'transactions',headerName:'Txns',width:75,type:'number'},
  {field:'actions',type:'actions',headerName:'Actions',width:110,getActions:(params:any)=>[
   <GridActionsCellItem key="eng" icon={<AddTaskOutlinedIcon/>} label="Engagement" onClick={()=>this.props.onCommit(params.row as BudgetExecutionRow)} showInMenu />,
   <GridActionsCellItem key="real" icon={<DoneAllOutlinedIcon/>} label="Réalisation" onClick={()=>this.props.onRealize(params.row as BudgetExecutionRow)} showInMenu />,
  ]},
 ];
 render(){return <Box><FDataGrid rows={this.props.rows||[]} columns={this.columns()} loading={this.props.loading} getRowId={(r:any)=>r.versionlineid}/></Box>}
}
